import React from 'react';
import { clientError } from '../clientLog';

/**
 * 局部錯誤邊界：包住可能出錯的子樹（例如字幕編輯器），
 * 避免單一元件崩潰導致整頁白畫面、使用者連轉錄結果都拿不到。
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
    // 畫面崩潰是使用者最說不清楚的問題，記進前端診斷日誌
    clientError('react_error', {
      label: this.props.label || '',
      message: String(error && error.message ? error.message : error),
      stack: String((info && info.componentStack) || '').slice(0, 300),
    });
  }

  reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="bg-white rounded-card border border-rose-200 p-6">
        <p className="font-bold text-rose-600 mb-1">
          ⚠️ {this.props.label || '這個區塊'}發生錯誤
        </p>
        <p className="text-sm text-ink-muted mb-3">
          轉錄結果仍然保留，可直接使用下方的下載按鈕；重試可恢復此區塊。
        </p>
        <pre className="text-xs bg-paper rounded-lg p-3 overflow-x-auto text-ink-muted mb-3">
          {String(error && error.message ? error.message : error)}
        </pre>
        <button
          onClick={this.reset}
          className="text-xs font-bold bg-brand text-white px-4 py-2 rounded-pill hover:bg-brand-hover transition-colors"
        >
          重試
        </button>
      </div>
    );
  }
}
